














































import {Vue, Component, Prop} from 'vue-property-decorator';
import {centerWinOptions} from '@/utils/commonUtils';

@Component
export default class ProductInquiryReplied extends Vue {
  @Prop({
    required: false,
    default: function() {
      return {inquiryNo: -1};
    },
    type: Object,
  })
  private readonly data!: {[propName: string]: any};
  private isShowReplaySwitch = false;
  private replyTxt = '';

  private get isDataEmpty(): boolean {
    this.replyTxt = '';
    return !this.data || Object.keys(this.data).length === 0;
  }

  private get repliedProductInquires(): [] {
    if (this.isDataEmpty) {
      return [];
    } else {
      if (this.data.repliedProductInquires) {
        return this.data.repliedProductInquires;
      } else {
        return [];
      }
    }
  }

  private get isAdmin(): boolean {
    return !this.isDataEmpty && this.data.admin && this.data.admin.adminNo > -1;
  }

  private get isShowReplay(): boolean {
    if (this.isDataEmpty) {
      return false;
    } else if (this.isShowReplaySwitch || this.repliedProductInquires.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  private get registerName(): string {
    if (this.isDataEmpty) {
      return '';
    } else if (this.isAdmin) {
      return this.registerName;
    } else if (this.data.memberStatus === 'EXPELLED') {
      return this.$t('PRODUCT_INQUIRY_REPLIED_ALERT_MSG1') as string; //탈퇴회원
    } else {
      const url = `/member/popup/crm/${this.data.registerNo}`;
      return `<a class="memberPopup" href="javascript:onclick=window.open('${url}','memberPopupCrm','${centerWinOptions(1060, 800)}')">${this.data.memberId} (${this.data.registerNo})</a>`;
    }
  }

  private fetchReplied() {
    const {inquiryNo, mallNo, memberId, memberStatus, admin, orderNo} = this.data;
    this.$emit('fetchReplied', {inquiryNo, member: {memberId, memberStatus}, mallNo, admin, orderNo});
  }

  private deleteReplied(inquiryNo: string, mallNo: string) {
    const txt = this.$t('PRODUCT_INQUIRY_REPLIED_ALERT_MSG2') as string; //고객이 확인 한 답변을 삭제할 경우, 추가 클레임이 발생할 수 있습니다.\r\n그래도 삭제하시겠습니까?
    if (confirm(txt)) {
      this.$api.deleteProductInquiriesByInquiryNo({params: {inquiryNo, mallNo}}).then(() => {
        this.fetchReplied();
        alert(this.$t('PRODUCT_INQUIRY_REPLIED_ALERT_MSG5')); //답변저장 완료
        // this.$emit('research');
      });
    }
  }

  private save() {
    if (!this.replyTxt.trim().length) {
      alert(this.$t('PRODUCT_INQUIRY_REPLIED_ALERT_MSG4')); //내용을 정확히 입력해주세요.
    } else {
      const params = {inquiryNo: this.data.inquiryNo};
      const data = {content: this.replyTxt};
      this.$api.postProductInquiriesReplay({params, data}).then(() => {
        this.fetchReplied();
        this.replyTxt = '';
        alert(this.$t('PRODUCT_INQUIRY_REPLIED_ALERT_MSG3')); //답변삭제 완료
        // this.$emit('research');
        let rowKey = $('input[name=\'listRadio\']:checked').parent().attr('data-row-key')
        $('[data-row-key=\''+ rowKey+'\'][data-column-name=\'replied\']').text('답변완료')
      });
    }
  }
}
